import { isRowingBlazers, isTheLittleBraCompany } from '../retailer';

export default function showAspenBenefits() {
  return !(isRowingBlazers() || isTheLittleBraCompany());
}
